import React, { Component } from 'react'
import Radium from 'radium'
import { Scrollbars } from 'react-custom-scrollbars'
import { connect } from 'react-redux'
import Waves from 'node-waves'

import Tabbar from './tabbar/tabbar'
import Images from '../Images/index2'
import StaticInvoice from './staticInvoice'

import HeadingSubtextContainer from '../../../HeadingSubtext/HeadingSubtextContainer'
import PricelistsList from '../../../PricelistsList/index'
import DatePickerRange from '../../../Common/datepickerRange2'

import Offers from './spreadsheets/offers'
import Others from './spreadsheets/others'
import Crew from './spreadsheets/crew'
import Activity from './spreadsheets/activity'
import Materiel from './spreadsheets/materiel'
import Measurements from './spreadsheets/measurements'
import DeliveryNotes from './spreadsheets/deliveryNotes'
import Invoices from './spreadsheets/invoices'

import InvoiceSummary from './summary'

import { attemptGetWorkplace } from '../Overview/actions'
import * as actions from './actions'

class Invoice extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeTab: 0,
            dailySel: {},
            hide: true,
            prev: []
        }
    }
    componentDidMount = () => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
        this.props.dispatch({ type: 'tilbud/PREV_IS_LOADING', status: true })
        actions.getPrevInvoices(this.props.params.workplaceId)
            .then((e) => {
                this.setState({
                    prev: e
                })
                this.props.dispatch({ type: 'tilbud/PREV_IS_LOADING', status: false })
            })
    };
    componentDidUpdate = (prevProps, prevState) => {
        Waves.attach('.waves-btn', ['waves-button']);
        Waves.attach('.waves-icon', ['waves-circle']);
    };
    componentWillMount = () => {
        const { params, dispatch } = this.props;
        dispatch(attemptGetWorkplace(params.departmentId, params.workplaceId));
        dispatch(actions.getWorkplaceDailyreportStats(params.workplaceId))
        actions.getPrevInvoices(this.props.params.workplaceId)
            .then((e) => {
                this.setState({
                    prev: e
                })
            })
    };
    renderDatepicker = () => {
        return (
            <div style={{ width: 300, paddingTop: 10, alignSelf: 'flex-end' }}>
                <div style={{ border: '2px solid lightgrey', padding: 10 }}>
                    <h3 style={{ paddingBottom: 10 }}>
                        Periode
                </h3>
                    <DatePickerRange
                        dates={this.props.dates}
                        onChange={(start, end) => {
                            let dateFrom = JSON.parse(JSON.stringify(start));
                            let dateTo = JSON.parse(JSON.stringify(end));
                            if (this.props.dates.start != dateFrom || this.props.dates.end != dateTo) {
                                this.props.dispatch(actions.getPCalcAndDailyreports(dateFrom, dateTo, this.props.params.workplaceId))
                            }
                        }}
                    />
                </div>
            </div>
        )
    }

    dateToString = (date) => {
        var days = ["Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "​​Lørdag"];
        var curr_date = date.getDate();
        var curr_month = date.getMonth() + 1;
        var curr_year = date.getFullYear();
        return days[date.getDay()] + " d." + curr_date + "/" + curr_month + " " + curr_year;
    }

    renderPrev = () => {
        return (
            <div style={{ border: '2px solid lightgrey', padding: 10, marginTop: 10 }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Tidligere estimater
                </h3>
                {this.props.prevLoading ?
                    <div style={{ opacity: 0.7, textAlign: 'center' }}>
                        <i className="fa fa-spinner fa-spin fa-3x" />
                    </div>
                    : null}
                {this.props.saved ? null :
                    <div
                        key={Math.random()}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            padding: 10,
                            cursor: 'pointer',
                            backgroundColor: '#5AA6C2',
                            color: 'white',
                            borderBottom: '1px solid lightgrey'
                        }}>
                        <div>
                            Nyt estimat
                        </div>
                        <div>
                            Igangværende
                        </div>
                    </div>
                }
                {this.state.prev.map((p, index) => {
                    let background = 'white'
                    let color = 'black'
                    if (this.props.selInv === index && this.props.saved) {
                        background = '#5AA6C2'
                        color = 'white'
                    } else if (index === 0 && this.props.selInv === 'john') {
                        background = '#5AA6C2'
                        color = 'white'
                    }
                    if(p.reduxState.indexOf('"deleted":true') !== -1){return null}
                    return (
                        <div
                            onClick={() => {
                                this.props.dispatch(actions.setPrevInvoice(p, index))
                                this.setState({
                                    activeTab: 4
                                })
                            }}
                            key={index}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                padding: 10,
                                cursor: 'pointer',
                                backgroundColor: background,
                                color: color,
                                borderBottom: '1px solid lightgrey'
                            }}>
                            <div>
                                Estimat nr: {this.state.prev.length - (index)}
                            </div>
                            <div>
                                Oprettet: {this.dateToString(new Date(p.createdAt))}
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    renderStamdata = () => {
        return (
            <div style={{ border: '2px solid lightgrey', padding: 10 }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Stamdata
                </h3>
                <HeadingSubtextContainer
                    updateSubtext={(text, index) => this.props.dispatch(actions.updateSubtext_ExtraInfo(text, index))}
                    updateHeading={(text, index) => this.props.dispatch(actions.updateHeading_ExtraInfo(text, index))}
                    addHeadingSubtext={() => this.props.dispatch(actions.addHeadingSubtext_ExtraInfo())}
                    headingSubtexts={this.props.stamdata}
                    noedit
                    ontAllowNewRow
                    headingStyle={{
                        fontSize: 12,
                        fontWeight: 500,
                        paddingLeft: 0
                    }}
                    subtextStyle={{
                        paddingLeft: 10
                    }}
                />
            </div>
        )
    }

    renderUdvidetInfo = () => {
        return (
            <div style={{ borderBottom: '2px solid lightgrey', borderRight: '2px solid lightgrey', borderLeft: '2px solid lightgrey', borderTop: '0px solid lightgrey', padding: 10 }}>
                <h3 style={{ paddingBottom: 10, }}>
                    Udvidet info
                </h3>
                <HeadingSubtextContainer
                    updateSubtext={(text, index) => this.props.dispatch(actions.updateSubtext_ExtraInfo(text, index))}
                    updateHeading={(text, index) => this.props.dispatch(actions.updateHeading_ExtraInfo(text, index))}
                    addHeadingSubtext={() => this.props.dispatch(actions.addHeadingSubtext_ExtraInfo())}
                    headingSubtexts={this.props.extraInfo}
                />
            </div>
        )
    }
    renderPricelists = () => {
        return (
            <div style={{ width: 424, height: 250, padding: 10, border: '2px solid lightgrey' }}>
                <h3>
                    Vælg Prisliste
                </h3>
                <div style={{ height: 250 - 70 }}>
                    <PricelistsList
                        onSelect={(id) => {
                            this.props.dispatch(actions.selectPriceList(id))
                        }}
                        selectedJohn={this.props.selPriceList}
                    />
                </div>
            </div>
        )
    }

    renderInvoiceSummary = () => {
        return (
            <div style={{ padding: 10, border: '2px solid lightgrey', height: 250, justifySelf: 'flex-end' }}>
                <h3 style={{ paddingBottom: 10 }}>
                    Sum
                </h3>
                <InvoiceSummary
                    others={this.props.others}
                    usage={this.props.usage}
                    crew={this.props.employeeHoursCalc.calcs}
                    offers={this.props.offers}
                    measurements={this.props.measurements}
                    activities={this.props.activities}
                    deliveryNotes={this.props.deliveryNotes}
                    invoices={this.props.invoices}
                />
            </div>
        )
    }

    renderTab1 = () => {
        return (
            <div style={styles.invoiceContainer}>
                <div
                    style={{ width: '100%' }}
                >
                    <h1 style={{ paddingBottom: 10, textAlign: 'center' }}>
                        Øvrige
                    </h1>
                    <Offers
                        id={this.props.offersId}
                        rows={this.props.offers}
                        offersKey={this.props.offersKey}
                        update={(index, offer) => this.props.dispatch(actions.updateOfferRow(index, offer))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addOfferRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <h1 style={{ paddingBottom: 10 }}>
                    Regningsarbejder
                </h1>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <h3 style={{
                        paddingBottom: 10
                    }}>
                        Mandskab
                    </h3>
                    <div style={{ width: '100%' }}>
                        <Crew
                            rows={this.props.employeeHoursCalc.calcs}
                            update={(fun, obj) => this.props.dispatch(actions.updateEmployeeFunction(fun, obj))}
                            recalc={() =>{}}
                            crewKey={this.props.crewKey}
                        />
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Aktiviteter
                    </h3>
                    <Activity
                        rows={this.props.activities}
                        activitiesKey={this.props.activitiesKey}
                        update={(index, activity) => this.props.dispatch(actions.updateActivityRow(index, activity))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addActivityRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Materiel
                    </h3>
                    <Materiel
                        addMateriel={(suggestion) => {
                            suggestion.id = suggestion.aggregateId
                            this.props.dispatch(actions.addMateriel(suggestion))
                        }}
                        rows={this.props.usage}
                        materiels={this.props.materiels}
                        materielsKey={this.props.usageKey}
                        type="Materiel"
                        update={(materiel, index) => this.props.dispatch(actions.updateMateriel(materiel, index))}
                        productDiscounts={this.props.productDiscounts}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addMaterielRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Materiale
                    </h3>
                    <Materiel
                        addMateriel={(suggestion) => {
                            suggestion.id = suggestion.aggregateId
                            this.props.dispatch(actions.addMateriel(suggestion))
                        }}
                        rows={this.props.usage}
                        materielsKey={this.props.usageKey}
                        materiels={this.props.materiels}
                        type="Materiale"
                        update={(materiel, index) => this.props.dispatch(actions.updateMateriel(materiel, index))}
                        productDiscounts={this.props.productDiscounts}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addMaterialeRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Opmåling
                    </h3>
                    <Measurements
                        rows={this.props.measurements}
                        measurementsKey={this.props.measurementsKey}
                        update={(measurement, index) => this.props.dispatch(actions.updateMeasurement(measurement, index))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addMeasurementsRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Følgesedler
                    </h3>
                    <DeliveryNotes
                        update={(deliveryNote, index) => this.props.dispatch(actions.updateDeliveryNote(deliveryNote, index))}
                        rows={this.props.deliveryNotes}
                        deliveryNotesKey={this.props.deliveryNotesKey}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addDeliveryNotesRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
                <div
                    style={{ width: '100%', paddingTop: 10, paddingBottom: 10 }}
                >
                    <h3 style={{ paddingBottom: 10 }}>
                        Diverse
                    </h3>
                    <Others
                        id={this.props.othersId}
                        rows={this.props.others}
                        offersKey={this.props.othersKey}
                        update={(index, offer) => this.props.dispatch(actions.updateOthersRow(index, offer))}
                    />
                    <div
                        style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                    >
                        <button
                            onClick={() => this.props.dispatch(actions.addOthersRow())}
                            className={"btn btn-primary waves-btn"}
                        >
                            Tilføj række
                        </button>
                    </div>
                </div>
            </div >
        )
    }

    renderAttachments = () => {
        return (
            <div>
                <Invoices
                    update={(invoice, index) => this.props.dispatch(actions.updateInvoice(invoice, index))}
                    rows={this.props.invoices}
                    updateBilag={(bilag, index) => this.props.dispatch(actions.updateBilag(bilag, index))}
                />
                <div
                    style={{ float: 'left', paddingTop: 10, paddingLeft: 5 }}
                >
                    <button
                        onClick={() => this.props.dispatch(actions.addInvoiceRow())}
                        className={"btn btn-primary waves-btn"}
                    >
                        Tilføj række
                        </button>
                </div>
            </div>
        )
    }

    renderImages = () => {
        return (
            <div style={{ height: '100%' }}>
                <Images params={this.props.params}
                    selected={this.props.selectedImages}
                    select={(pic) => this.props.dispatch(actions.updateSelectedImages(pic))}
                    deselect={(pic) => this.props.dispatch(actions.updateSelectedImages(pic))}
                />
            </div>
        )
    }


    onTabbuttonClicked = (key) => {
        this.setState({
            activeTab: key
        })
    }

    render() {
        return (
            <div style={styles.container} >
                {
                    this.props.loading ?
                        <div style={{ position: 'absolute', top: '50%', left: '50%', opacity: 0.7 }}>
                            <i className="fa fa-spinner fa-spin fa-3x" />
                        </div>
                        : null
                }
                < div style={{ height: '6%', float: 'right', paddingRight: 10 }}>
                    <div style={{
                        backgroundColor: '#f1f1f1', '@media print': {
                            'display': 'none'
                        }
                    }}>
                        <Tabbar
                            activeTab={this.state.activeTab}
                            onTabbuttonClicked={this.onTabbuttonClicked}
                            tabs={[
                                'Forside',
                                'Opstilling',
                                'Vedlæg billeder',                                
                                'Vedlæg bilag',
                                'Gennemse',
                            ]} />
                    </div>
                </div>
                <div style={{
                    height: '94%',
                }}>
                    <Scrollbars
                        id={"SCROLLER"}
                        key={this.state.activeTab}
                        style={{ height: '100%', width: '100%' }}
                        renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                        renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                    >
                        {this.state.activeTab === 0 ?
                            <div style={styles.invoiceContainer}>
                                <div style={{ width: 245 }} >
                                    {this.renderStamdata()}
                                </div>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}>
                                    {this.renderPricelists()}
                                    {this.renderDatepicker()}
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column'
                                    }}>
                                    {this.renderInvoiceSummary()}
                                    {this.renderPrev()}
                                </div>
                            </div>
                            : null}
                        {this.state.activeTab === 1 ?
                            this.renderTab1()
                            : null}
                            {this.state.activeTab === 2 ?
                            this.renderImages()
                            : null}
                        {this.state.activeTab === 3 ?
                            this.renderAttachments()
                            : null}
                        {this.state.activeTab === 4 ?
                            <StaticInvoice
                                workplaceId={this.props.params.workplaceId}
                                workplace={this.props.workplace}
                                savee={() => {
                                    setTimeout(() => {
                                        actions.getPrevInvoices(this.props.params.workplaceId)
                                            .then((e) => {
                                                this.setState({
                                                    prev: e
                                                })
                                            })
                                    }, 3000)
                                }} />
                            : null}
                    </Scrollbars>
                </div >
            </div >
        );
    }
}

const styles = {
    container: {
        width: '100%',
        height: '100%',
        position: 'relative',
        '@media (min-width: 1200px)': {
            position: 'relative',
            marginLeft: 'auto',
            marginRight: 'auto',
            maxWidth: '1170px',
            width: '100%'
        },
    },
    invoiceContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        padding: 10,
    },
    check: {
        paddingTop: 4,
        paddingRight: 5,
    },
}

const selectProps = state => {
    return {
        workplace: state.workplaceOverviewReducer.workplace,
        ...state.TilbudReducer,
    };
}

export default connect(selectProps)(Radium(Invoice));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Tilbud/index.js